module.exports = __webpack_public_path__ + "static/media/C3DC_User_Guide_R9_V2.144dff2a.pdf";